import { getItemProfileForSite } from '../items/get-item-profile-for-site';
export const getOrderTipOptionsForSite = (siteId) => {
    var _a;
    return (_a = getItemProfileForSite(siteId)) === null || _a === void 0 ? void 0 : _a.orderTipOptions;
};
//# sourceMappingURL=get-order-tip-options-for-site.js.map